import { z } from 'zod';

import { ReferenceIdSchema } from './primitives';

export const ReferenceSchema = z
  .record(ReferenceIdSchema, z.boolean())
  .describe(
    'A map of entity IDs to boolean flags indicating referenced entities. ' +
      'Used to track dependencies between entities in the event sourcing system. ' +
      "Example: { 'entity-1': true, 'entity-2': true }. " +
      'Enables proper cascade handling and validation.',
  );

export const EnvironmentSchema = z
  .enum(['sandbox', 'pre-release', 'live'], {
    message: "Environment must be one of 'sandbox', 'pre-release', or 'live'",
  })
  .describe(
    'Deployment environment identifier. ' +
      "'sandbox' is for testing, 'pre-release' for staging, and 'live' for production.",
  );

export type ReferenceMap = z.infer<typeof ReferenceSchema>;
export type Environment = z.infer<typeof EnvironmentSchema>;
